import $axios from '@/store/axios-instance.js';

export const moduleName = 'profile'

export const mutationType = {
    getProfile : `[${moduleName}] getProfile`,
    update : `[${moduleName}] update`,
    updateImage : `[${moduleName}] updateImage`,
}

export const actionType = {
    getProfile : `[${moduleName}] getProfile`,
    changePassword : `[${moduleName}] changePassword`,
    update : `[${moduleName}] update`,
    updateImage : `[${moduleName}] updateImage`,
}

export const getterType = {
    profile: `[${moduleName}] profile`
}

export default {
    state: {
        profile: null
    },
    mutations: {
        [mutationType.getProfile](state, entityList) {
            state.profile = entityList
        },
        [mutationType.update](state, entityList) {
            state.profile.displayName = entityList.displayName
        },
    },
    actions: {
        [actionType.getProfile](context){
            return new Promise((resolve, reject) => {
                $axios
                    .get('profile')
                    .then(response => {
                        context.commit(mutationType.getProfile, response.data)

                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        [actionType.changePassword](context, payload){
            return new Promise((resolve, reject) => {
                $axios
                    .put('profile', payload)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        [actionType.update](context, payload){
            return new Promise((resolve, reject) => {
                $axios
                    .put('profile', payload)
                    .then(response => {
                        context.commit(mutationType.update, payload)
                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        [actionType.updateImage](context, payload){
            return new Promise((resolve, reject) => {
                let formData = new FormData()
                if (payload.image) {
                    formData.append('image', payload.image)
                }

                $axios
                    .put('profile', formData)
                    .then(response => {
                        context.commit(mutationType.getProfile, response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
    },
    getters: {
        [getterType.profile](state){
            return state.profile
        }
    }
}